import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useRef } from 'react';
import { X } from 'lucide-react';
/**
 * BottomSheet Component
 * A mobile-optimized modal that slides up from the bottom
 * Supports dragging to dismiss on touch devices
 */
export function BottomSheet({ isOpen, onClose, title, children, maxHeight = '80vh', showDragHandle = true, onBackdropClick }) {
    const [isDragging, setIsDragging] = useState(false);
    const [startY, setStartY] = useState(0);
    const [translateY, setTranslateY] = useState(0);
    const sheetRef = useRef(null);
    if (!isOpen) {
        return null;
    }
    const handleTouchStart = (e) => {
        setIsDragging(true);
        setStartY(e.touches[0].clientY);
    };
    const handleTouchMove = (e) => {
        if (!isDragging)
            return;
        const currentY = e.touches[0].clientY;
        const diff = currentY - startY;
        // Only allow dragging downward
        if (diff > 0) {
            setTranslateY(diff);
        }
    };
    const handleTouchEnd = () => {
        setIsDragging(false);
        // Close if dragged more than 100px
        if (translateY > 100) {
            onClose();
        }
        else {
            // Snap back to top
            setTranslateY(0);
        }
    };
    const handleBackdropClick = () => {
        if (onBackdropClick) {
            onBackdropClick();
        }
        else {
            onClose();
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "fixed inset-0 z-50 bg-black/50 animate-fade-in", onClick: handleBackdropClick }), _jsxs("div", { ref: sheetRef, className: "fixed bottom-0 left-0 right-0 z-50 rounded-t-3xl overflow-hidden transition-transform duration-200", style: {
                    backgroundColor: 'var(--bg-elevated)',
                    maxHeight,
                    paddingBottom: 'env(safe-area-inset-bottom)',
                    transform: `translateY(${isDragging ? translateY : 0}px)`,
                    opacity: isDragging ? 0.95 : 1
                }, onTouchStart: handleTouchStart, onTouchMove: handleTouchMove, onTouchEnd: handleTouchEnd, children: [showDragHandle && (_jsx("div", { className: "flex justify-center pt-3 pb-2 cursor-grab active:cursor-grabbing", children: _jsx("div", { className: "w-10 h-1 rounded-full bg-gray-300", style: { opacity: 0.5 } }) })), title && (_jsxs("div", { className: "flex items-center justify-between px-6 pb-4 border-b border-[var(--border-color)]", children: [_jsx("h2", { className: "text-xl font-semibold", style: { color: 'var(--text-primary)' }, children: title }), _jsx("button", { onClick: onClose, className: "p-2 rounded-full hover:bg-gray-100 active:bg-gray-200", style: {
                                    backgroundColor: 'var(--bg-base)',
                                    transition: 'background-color 150ms ease'
                                }, children: _jsx(X, { className: "w-5 h-5", style: { color: 'var(--text-secondary)' } }) })] })), _jsx("div", { className: "overflow-y-auto px-6 pb-6", style: {
                            maxHeight: `calc(${maxHeight} - ${title ? '140px' : '80px'})`
                        }, children: children })] })] }));
}
